import { Box, Container, VStack, Text } from '@bpba/ui-components';
import { Banner } from '../components/Banner';
import { Title } from '../components/Title';
import { Info } from '../components/Info';
import AdhesionComercioCanjeComponente from '../components/AdhesionComercioCanjeComponente';
import { CANJE_POP_CDNI } from '../Constantes';
import { infoAdhesionComercioCanje } from '../components/Listas';




export const AdhesionComerciosCanje: React.FC = () => {


    return (
        <Container>
            <VStack>
                <VStack>
                    <Banner borderRadius={['0px', '8px']} url={CANJE_POP_CDNI} />
                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Title title={'Potenciá tus ventas con los beneficios de Cuenta DNI'} ></Title>
                                <Text fontSize={"18px"} lineHeight={"20px"} fontWeight={500} tabIndex={0}>Cobrá a tus clientes y ofrecé un ahorro exclusivo.</Text>                                <Info infoList={infoAdhesionComercioCanje} info={''} ></Info>
                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <AdhesionComercioCanjeComponente />
                        </Box>
                    </Box>
                    <Box py={4} px={['16px', null, null, '50px']}>
                        <Text fontSize={"12px"} lineHeight={"18px"} textAlign={"justify"} tabIndex={0}>
                            Conocé más  de los beneficios de Cuenta DNI en: <a href='https://www.bancoprovincia.com.ar/cuentadni/contenidos/cdnibeneficios' style={{ color: "#3C3C3B" }} >www.bancoprovincia.com.ar/cuentadni/contenidos/cdnibeneficios</a>
                        </Text>
                    </Box>
                </VStack>

            </VStack>
        </Container>

    )

}



